export default "__VITE_ASSET__B_xxSPw3__"